module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/piechart.7f66c509.svg";